import * as Mutations from '../modules/mobile/mutations';

export const CheckDevicePlugin = store => {
    store.commit(Mutations.SET_IS_MOBILE, checkMobile());
    window.addEventListener('resize', () => {
        store.commit(Mutations.SET_IS_MOBILE, checkMobile());
    });
};

function checkMobile() {
    return window.innerWidth < 900;
}


// WEBPACK FOOTER //
// ./src/store/plugins/check-device.plugin.js